import Loadable from 'react-loadable';
import { LoadingIndicator } from 'web-ui-kit/loading';

import AdminModalButton from './AdminButton';

export default Loadable({
  loader: () => import('./AdminModal' /* webpackChunkName: "AdminModal" */),
  loading: LoadingIndicator
});

export { AdminModalButton };
